import { render, staticRenderFns } from "./XmHeader.vue?vue&type=template&id=b51403e2"
import script from "./XmHeader.vue?vue&type=script&lang=js"
export * from "./XmHeader.vue?vue&type=script&lang=js"
import style0 from "./XmHeader.vue?vue&type=style&index=0&id=b51403e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports